import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import { FaPlaneDeparture } from "react-icons/fa";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/autoplay";
import "../Vender/css/TravelPartner.css";
import { getAllTravelPartner } from "../api/travelPartner.api";

const TravelPartner = () => {
  const [travelPartners, setTravelPartners] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const sliderRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getAllTravelPartner();
        console.log("Travel Partners API Response:", data);
        setTravelPartners(data?.travelPartner || []);
      } catch (error) {
        console.error("Error fetching travel partners:", error);
        // Set mock data immediately
        setTravelPartners([
          {
            _id: "1",
            company_name: "Air India",
            image:
              "https://via.placeholder.com/150x80/ff0000/ffffff?text=Air+India",
          },
          {
            _id: "2",
            company_name: "Emirates",
            image:
              "https://via.placeholder.com/150x80/cc9900/ffffff?text=Emirates",
          },
          {
            _id: "3",
            company_name: "Qatar Airways",
            image:
              "https://via.placeholder.com/150x80/660066/ffffff?text=Qatar",
          },
          {
            _id: "4",
            company_name: "Singapore Airlines",
            image:
              "https://via.placeholder.com/150x80/0066ff/ffffff?text=Singapore",
          },
          {
            _id: "5",
            company_name: "Lufthansa",
            image:
              "https://via.placeholder.com/150x80/ffcc00/000000?text=Lufthansa",
          },
        ]);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 },
    );

    if (sliderRef.current) {
      observer.observe(sliderRef.current);
    }

    return () => {
      if (sliderRef.current) {
        observer.unobserve(sliderRef.current);
      }
    };
  }, []);

  // Ensure we have enough items for smooth loop
  const duplicatedPartners =
    travelPartners.length > 0
      ? [...travelPartners, ...travelPartners, ...travelPartners]
      : [];

  return (
    <section
      className={`airline-marquee ${isVisible ? "visible" : ""}`}
      ref={sliderRef}
      style={{ minHeight: "200px" }} // Ensure section has height
    >
      <div className="airline-container">
        {/* Header */}
        <div className="airline-header">
          {/* <div className="header-badge">
            <FaPlaneDeparture />
            <span>Airline Partners</span>
          </div> */}
          <h2 className="header-title">Fly With The Best</h2>
        </div>

        {/* Marquee Track */}
        <div className="marquee-wrapper">
          <Swiper
            modules={[Autoplay, FreeMode]}
            spaceBetween={60}
            slidesPerView="auto"
            freeMode={{
              enabled: true,
              momentum: false,
            }}
            loop={duplicatedPartners.length >= 3} // Only enable loop if we have enough slides
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            }}
            speed={3000}
            allowTouchMove={false}
            className="marquee-slider"
            onSwiper={(swiper) => swiper.autoplay?.start()}
          >
            {duplicatedPartners.length > 0 ? (
              duplicatedPartners.map((partner, index) => (
                <SwiperSlide key={index} style={{ width: "auto" }}>
                  <div className="partner-logo">
                    <img
                      src={partner.image || "/assets/images/placeholder.jpg"}
                      alt={partner.company_name || "Airline Partner"}
                    />
                  </div>
                </SwiperSlide>
              ))
            ) : (
              <SwiperSlide>
                <p className="no-partners">No airline partners available</p>
              </SwiperSlide>
            )}
          </Swiper>

          {/* Fade Edges */}
          <div className="fade-edge fade-left"></div>
          <div className="fade-edge fade-right"></div>
        </div>

        {/* Bottom Info */}
        {/* <div className="airline-footer">
          <p>
            Trusted by <strong>{travelPartners.length || 0}+</strong> global
            airline partners
          </p>
        </div> */}
      </div>
    </section>
  );
};

export default TravelPartner;
